// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2h51R","rootNoMargin":"styles_rootNoMargin__1-EG3"};